// @flow

import type { Node } from "react";
import React from "react";

import { VideoPlayer } from "@/components";
import type { VideoPlayerAspectRatio } from "@/components/VideoPlayer/VideoPlayer";
import JsonPageRenderer from "@/utils/JsonPageRenderer/JsonPageRenderer";
import type { ItemRenderer, PageItem } from "@/utils/JsonPageRenderer/types";

interface VideoPageItem extends PageItem {
    props: {
        [string]: any,
        file: string,
        id: string,
        aspectRatio: VideoPlayerAspectRatio,
        stretching?: 'uniform' | 'exactfit' | 'fill' | 'none',
        controls: boolean | "sound-only",
        allowMultipleVideoPlayback: boolean,
    };
}

/**
 * Converts an ImagePageItem into a <img> node.
 */
class VideoPlayerRenderer implements ItemRenderer<VideoPageItem> {
    render(context: JsonPageRenderer, item: VideoPageItem): Node {
        return (
            <VideoPlayer
                key={item.id}
                playerId={item.props.id}
                playerScript="https://cdn.jwplayer.com/libraries/TtQDdgxk.js"
                file={item.props.file}
                aspectRatio={item.props.aspectRatio}
                stretching={item.props.stretching}
                controls={item.props.controls}
                allowMultipleVideoPlayback={
                    item.props.allowMultipleVideoPlayback
                }
            />
        );
    }

    match(item: PageItem): VideoPageItem | null {
        if (item.type === "video") {
            return item;
        }
        return null;
    }
}

export default VideoPlayerRenderer;
